import axios from "axios";
import { defaultEndPointDetails } from "../utils/const.utils";

export function getWalletsByNetwork(networkId) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/wallets/wbn/list?networkId=${networkId}&sortKey=createdAt&sortOrder=1`
  );
}

export function getWallets() {
  return axios.get(`${defaultEndPointDetails.baseUrl}/api/v1/wallets/wbn/list?sortKey=createdAt&sortOrder=1`);
}
